import { memo, useEffect, useRef } from "react";
import { useTheme } from "@/context/ThemeContext";

/** Embed genérico de widgets TradingView que acompanha o tema da plataforma. */
export const TradingViewEmbed = memo(({ script, config, height = 560, testId, copyright }) => {
  const container = useRef(null);
  const { theme } = useTheme() || { theme: "dark" };

  useEffect(() => {
    const node = container.current;
    if (!node) return;
    node.replaceChildren();
    const holder = document.createElement("div");
    holder.className = "tradingview-widget-container__widget";
    node.appendChild(holder);
    const el = document.createElement("script");
    el.src = `https://s3.tradingview.com/external-embedding/${script}`;
    el.type = "text/javascript";
    el.async = true;
    el.text = JSON.stringify({
      ...config,
      colorTheme: theme === "light" ? "light" : "dark",
      backgroundColor: theme === "light" ? "#ffffff" : "#0A0E16",
      widgetFontColor: theme === "light" ? "#0F0F0F" : "#E6EDF7",
      isTransparent: false,
      autosize: true,
      width: "100%",
      height,
    });
    node.appendChild(el);
    return () => { node.replaceChildren(); };
  }, [script, config, theme, height]);

  return (
    <div className="overflow-hidden rounded-md border border-[#141A26] bg-[#0A0E16]" data-testid={testId}>
      <div className="tradingview-widget-container" ref={container} style={{ height }} />
      {copyright ? <p className="px-4 pb-3 text-xs text-[#5B6579]">{copyright}</p> : null}
    </div>
  );
});
